import { BFF_API_ROUTES } from 'constants/apiRoutes';

import { baseRTKApi } from 'shared/api/baseApi';

import type { ILoanChartFilter } from '../types';

export const loanChartFiltersApi = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    getLoanChartFilters: build.query<ILoanChartFilter[], void>({
      query: () => BFF_API_ROUTES.getLoanChartFilters,
    }),
  }),
});

export const { useGetLoanChartFiltersQuery } = loanChartFiltersApi;
